import { Card, Grid, Stack, Tooltip, Box, Typography } from "@mui/material";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import moment from "moment";
import MDTypography from "components/MDTypography";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { coachupAction } from "redux/slice/coachup";
import Loader from "utils/Loader";
import InfoIcon from "@mui/icons-material/Info";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import AnalyticsCard from "./AnalyticsCard";
import UsersTable from "./UsersTable";

function MyTeam() {
  const theme = useTheme();
  const isMobileDisplay = useMediaQuery(theme.breakpoints.only("xs"));
  const dispatch = useDispatch();
  const loginUserState = useSelector((state) => state.loginUser.loginUserState);
  const myTeamReports = useSelector((state) => state.coachup.myTeamReports);
  const reportsAssignedByUser = useSelector((state) => state.coachup.reportsAssignedByUser);
  const [directReportsPayload, setDirectReportsPayload] = useState({
    searchText: "",
    pageSize: 10,
    pageNumber: 0,
    timezone: loginUserState.timezone || moment.tz.guess(),
  });
  const [otherUsersPayload, setOtherUsersPayload] = useState({
    searchText: "",
    pageSize: 10,
    pageNumber: 0,
  });

  useEffect(() => {
    dispatch(coachupAction.getMyTeamReportsRequest(directReportsPayload));
  }, [directReportsPayload]);

  useEffect(() => {
    dispatch(coachupAction.getReportsAssignedByUserRequest(otherUsersPayload));
  }, [otherUsersPayload]);

  return (
    <MDBox mt={5}>
      <Grid container spacing={3}>
        <Grid item xs={6} lg={3}>
          <AnalyticsCard
            color="dark"
            icon="reviews"
            title="Ready to Review"
            count={myTeamReports.readyForReview}
          />
        </Grid>
        <Grid item xs={6} lg={3}>
          <AnalyticsCard
            color="primary"
            icon="leaderboard"
            title={`${moment
              .tz(undefined, loginUserState.timezone || moment.tz.guess())
              .format("MMMM")} Completion`}
            count={`${myTeamReports.completionPercents}%`}
          />
        </Grid>
      </Grid>

      <MDBox mt={3}>
        <MDBox sx={{ position: "relative" }}>
          <Loader loading={false} />
          <Card>
            <Stack>
              <Stack
                p={2}
                pb={0}
                direction="row"
                spacing={1}
                justifyContent="space-between"
                alignItems="baseline"
              >
                <Box display="flex">
                  <MDTypography variant="h5" pr={1}>
                    Direct Reports
                  </MDTypography>
                  {!isMobileDisplay && (
                    <Tooltip title="My Reports Assigned Templates.">
                      <InfoIcon />
                    </Tooltip>
                  )}
                </Box>
                {myTeamReports.count > 0 && (
                  <Box>
                    <MDInput
                      sx={{ mb: 2 }}
                      label="Search Employee"
                      value={directReportsPayload.searchText}
                      onChange={(event) =>
                        setDirectReportsPayload((prev) => ({
                          ...prev,
                          searchText: event.target.value,
                        }))
                      }
                    />
                  </Box>
                )}
              </Stack>
              {myTeamReports.count > 0 ? (
                <UsersTable
                  payload={directReportsPayload}
                  setPayload={setDirectReportsPayload}
                  count={myTeamReports.count}
                  users={myTeamReports.data}
                />
              ) : (
                <Typography sx={{ p: "1rem", fontSize: "0.9rem", fontWeight: "400" }}>
                  You have no Direct Reports
                </Typography>
              )}
            </Stack>
          </Card>
        </MDBox>
      </MDBox>

      <MDBox mt={3}>
        <MDBox sx={{ position: "relative" }}>
          <Loader loading={false} />
          <Card>
            <Stack>
              <Stack
                p={2}
                pb={0}
                direction="row"
                spacing={1}
                justifyContent="space-between"
                alignItems="baseline"
              >
                <Box display="flex">
                  <MDTypography variant="h5" pr={1}>
                    Others Reports
                  </MDTypography>
                  {!isMobileDisplay && (
                    <Tooltip title="Assigned templates of non-direct reports.">
                      <InfoIcon />
                    </Tooltip>
                  )}
                </Box>
                {reportsAssignedByUser.count > 0 && (
                  <Box>
                    <MDInput
                      sx={{ mb: 2 }}
                      label="Search Employee"
                      value={otherUsersPayload.searchText}
                      onChange={(event) =>
                        setOtherUsersPayload((prev) => ({
                          ...prev,
                          searchText: event.target.value,
                        }))
                      }
                    />
                  </Box>
                )}
              </Stack>
              {reportsAssignedByUser.count > 0 ? (
                <UsersTable
                  count={reportsAssignedByUser.count}
                  payload={otherUsersPayload}
                  setPayload={setOtherUsersPayload}
                  users={reportsAssignedByUser.data}
                />
              ) : (
                <Typography sx={{ p: "1rem", fontSize: "0.9rem", fontWeight: "400" }}>
                  You have no Other Reports
                </Typography>
              )}
            </Stack>
          </Card>
        </MDBox>
      </MDBox>
    </MDBox>
  );
}

export default MyTeam;
